
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issues",
      function () {
        return require("private-next-pages/issues.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/issues"])
      });
    }
  